import React, { useState } from "react";
import { Input} from "reactstrap";

const Search = ({ onSearch, placeholder = "Search" }) => {
    const [search, setSearch] = useState("");

    const onInputChange = value => {
        setSearch(value);
        onSearch(value);
    };
    return (
        <Input
            bsSize="sm"
            type="text"
            // className="form-control"
            style={{ width: "240px" }}
            placeholder={placeholder}
            value={search}
            onChange={e => onInputChange(e.target.value)}
        />
    );
};

export default Search;